import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  itemsContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4,0.5fr)',

    gap: 10,
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: 'repeat(2,1fr)'
    }
  },
  formControlItem: {
    width: '80%',
    marginLeft: '1%',
    // border: `1px solid ${lighten(theme.palette.secondary.light, 0.5)}`,
    marginBottom: 8,
    borderRadius: 24,
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  title: {
    marginBottom: 12
  },
  titleSkeleton: {
    width: '60%'
  },
  root: {
    marginBottom: 32
  },
  formControlItemSkeleton: {
    display: 'flex',
    padding: '12px 10px'
  },
  checkboxSkeleton: {
    width: '80%',
    marginLeft: '1%',
    // border: `1px solid ${lighten(theme.palette.secondary.light, 0.5)}`,
    marginBottom: 8,
    borderRadius: 24,
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  checkboxLabelSkeleton: {
    width: '70%'
  }
}))

export default useStyles
